import {capitalize} from '../../utils/string'
export default class Module {
  constructor (name, operations) {
    const resourceName = capitalize(name)
    this.state = {
      [`${name}List`]: {
        data: [],
        total: 0
      },
      [`${name}`]: {}
    }

    this.mutations = {
      [`set${resourceName}List`](state, data) {
        state[`${name}List`] = data
      },
      [`set${resourceName}`](state, data) {
        state[name] = data
      }
    }

    this.actions = {
      async [`load${resourceName}List`]({ commit }, params) {
        const resp = await operations.list(params)
        commit(`set${resourceName}List`, {
          data: resp.data.list ? resp.data.list : resp.data[`${name}_list`],
          total: resp.data.total
        })
        return resp.data.list ? resp.data.list : resp.data[`${name}_list`]
      },
      [`add${resourceName}`]({ commit }, data) {
        return operations.add(data)
      },
      async [`load${resourceName}`]({ commit }, id) {
        const resp = await operations.one(id)
        // DEPRECATED: delete resp.data.list[0] after new API release
        commit(`set${resourceName}`, Array.isArray(resp.data.list) && resp.data.list.length > 0 ? resp.data.list[0] : resp.data)
        return resp.data
      },
      async [`update${resourceName}`]({ commit }, data) {
        return await operations.update(data)
      },
      async [`delete${resourceName}`]({ commit }, data) {
        return await operations.delete(data)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./packages/helper/module/index.js